<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <section class="white">
    <div
      class="content-wrapper pos-rel-md refer-title-container"
      *ngIf="!header?.image"
    >
      <h1
        class="ta-center refer-title"
        *ngIf="!pageRetrievalError && !header?.image"
      >
        {{ pageData.title }}
      </h1>
    </div>
    <div
      class="refer-header-banner pos-rel-md"
      *ngIf="!pageRetrievalError && header?.image"
    >
      <img
        [src]="header?.image?.data?.attributes?.url"
        [alt]="header?.image?.data?.attributes?.name"
      />
    </div>
    <div
      class="refer-video-banner-container"
      *ngIf="!pageRetrievalError && !header?.image && pageData.banner_video"
    >
      <div class="refer-video-banner">
        <app-youtube-video
          videoId="{{ pageData.banner_video }}"
        ></app-youtube-video>
      </div>
    </div>
    <div class="content-wrapper" *ngIf="pageRetrievalError">
      <app-page-retrieval-error
        *ngIf="pageRetrievalError"
      ></app-page-retrieval-error>
    </div>
    <div class="content-wrapper" *ngIf="!pageRetrievalError">
      <p class="refer-intro">{{ pageData.intro }}</p>
      <h2 class="refer-email-heading">{{ pageData.email_heading }}</h2>
      <p class="refer-email-intro">{{ pageData.email_intro }}</p>
      <div class="referral-success" *ngIf="submissionComplete">
        <p>{{ pageData.referrals_sent_message }}</p>
      </div>
      <form
        *ngIf="!submissionComplete"
        class="refer-form"
        [formGroup]="referForm"
        (ngSubmit)="submitReferForm()"
      >
        <div formArrayName="emails">
          <div
            class="refer-form-row"
            *ngFor="let email of getControls(); let i = index"
            [formGroupName]="i"
          >
            <input
              class="refer-email-input"
              type="email"
              formControlName="emailAddress"
              [attr.name]="'email_' + i"
              placeholder="Enter email"
              autocomplete="email"
              [class.error]="
                (submitted || getControls()[i].get('emailAddress')?.dirty) &&
                getControls()[i].get('emailAddress')?.errors
              "
            />
            <a
              *ngIf="getControls().length > 1"
              (click)="removeOrClearEmail(i)"
              class="refer-delete-email"
              >remove</a
            >
            <div
              class="refer-email-error"
              *ngIf="
                (submitted || getControls()[i].get('emailAddress')?.dirty) &&
                getControls()[i].get('emailAddress')?.errors
              "
            >
              <p>Please enter a valid email address</p>
            </div>
          </div>
        </div>
        <div class="add-clear-container">
          <a class="refer-add-email" (click)="addEmailFormGroup()">{{
            pageData.add_link_text
          }}</a>
          <a class="refer-clear-emails" (click)="clearEmails()">{{
            pageData.clear_link_text
          }}</a>
        </div>
        <div class="form-errors" *ngIf="submitted && !referForm.valid">
          <p class="form-error">
            There are errors with your submission. Please correct them and
            re-submit.
          </p>
        </div>
        <div class="form-errors" *ngIf="submissionError">
          <p class="form-error" *ngIf="formErrorText">
            {{ formErrorText }}
          </p>
          <p class="form-error" *ngIf="!formErrorText">
            There was an error submitting your referrals. Please try again or
            <a routerLink="/contact-us/form">contact us</a> for assistance.
          </p>
        </div>
        <button
          type="submit"
          class="button secondary"
          [class.button-loading]="
            submitted &&
            referForm.valid &&
            !(submissionError || submissionComplete)
          "
        >
          <span>{{ pageData.send_text }}</span>
        </button>
      </form>
      <h2 class="refer-share-heading">{{ pageData.share_heading }}</h2>
      <div class="refer-share-link-and-button">
        <a
          class="refer-share-url"
          *ngIf="pageData.share_link"
          [href]="
            pageData.share_link + '?referrer=' + authService.currentUser?.email
          "
          >{{
            pageData.share_link + '?referrer=' + authService.currentUser?.email
          }}</a
        >
        <!-- container necessary because linting -->
        <ng-container *ngIf="pageData.share_link">
          <button
            *ngIf="pageData.share_link"
            ngxClipboard
            class="button refer-copy-link"
            [class.secondary]="!linkCopied"
            [cbContent]="
              pageData.share_link +
              '?referrer=' +
              authService.currentUser?.email
            "
            (cbOnSuccess)="linkCopied = true"
          >
            {{
              linkCopied
                ? pageData.copied_button_text
                : pageData.copy_button_text
            }}
          </button>
        </ng-container>
      </div>
      <h2 class="refer-how-heading">{{ pageData.how_it_works_heading }}</h2>
      <div class="refer-how-content">
        {{ pageData.how_it_works_content | marked }}
      </div>
      <h3 class="refer-terms-heading">{{ pageData.terms_heading }}</h3>
      <div class="refer-terms-content">
        {{ pageData.terms_content | marked }}
      </div>
    </div>
  </section>
</div>
